<template>
    <div class="float-right mr-3">
        <b-select
            v-model="localMonth"
            size="sm"
            style="height: 20px; padding-top: 0"
            :options="monthOptions"
            @change="updateMonth"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'MonthHandler',

    mixins: [DataUpdater],

    data() {
        return {
            localMonth: 0,
            monthOptions: [
                { value: 1, text: 'janvier' },
                { value: 2, text: 'février' },
                { value: 3, text: 'mars' },
                { value: 4, text: 'avril' },
                { value: 5, text: 'mai' },
                { value: 6, text: 'juin' },
                { value: 7, text: 'juillet' },
                { value: 8, text: 'août' },
                { value: 9, text: 'septembre' },
                { value: 10, text: 'octobre' },
                { value: 11, text: 'novembre' },
                { value: 12, text: 'décembre' },
            ],
        }
    },

    created() {
        this.$store.commit('browsing/INIT_MONTH')
        this.localMonth = this.month
    },

    methods: {
        updateMonth() {
            this.$store.commit('browsing/SET_MONTH', this.localMonth)
            this.updateData()
        },
    },

    computed: {
        ...mapState({
            month: (state) => state.browsing.month,
        }),
    },
}
</script>

<style scoped></style>
